/* global translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Input } from '../forms';

const DeleteMeEmail = (props) => {
  const {
    name,
    value,
    error,
    onChange,
  } = props;

  return (
    <div key="email" className={`form-group mbl${error ? ' error' : ''}`}>
      <label
        htmlFor="MembersEmail"
      >
        {get(translations, 'txt: Mēs no sirds priecātos dzirdēt Jūsu stāstu, uzraksti, kā varam ar Tevi sazināties, kā arī nodot Tev pateicību par iedvesmu mums', '')}
      </label>
      <Input
        name={name}
        value={value}
        placeholder={get(translations, 'txt: Ievadi savu E-pastu', '')}
        className="form-control"
        id="MembersEmail"
        doneTyping={onChange}
      />
      {error && (
        <div className="error">
          <div className="inner">
            {error}
          </div>
        </div>
      )}
    </div>
  );
};

DeleteMeEmail.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

DeleteMeEmail.defaultProps = {
  name: '',
  value: '',
  error: '',
};

export default DeleteMeEmail;
